












































import RefsPerson from "@/components/utility/RefsPerson.vue";
import { handleError } from "@/lib/utility/handleError";
import { IPerson } from "@/models/person.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { PersonSearchModule } from "@/store/modules/search.store";
import { debounce } from "debounce";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: { RefsPerson },
  filters: {}
})
export default class PersonSelection extends Vue {
  loadingLocal = false;
  search = "";

  @Prop({ default: null })
  value!: IPerson | null;

  @Prop({ default: true })
  cache!: boolean;

  get selected(): IPerson | null {
    return this.value;
  }

  set selected(value: IPerson | null) {
    this.$emit("input", value);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  get items() {
    return PersonSearchModule.filtered || [];
  }

  @Watch("search")
  async onSearchChange(search: string) {
    if (search) {
      this.debounceQuerySelections(search);
    }
  }

  // We have to debounce the input of the user to not fire backend calls after each keystroke
  debounceQuerySelections = debounce(this.querySelections, 500);

  /**
   *  Searches the API directly not via the store
   * @param search the search parameter
   */
  async querySelections(search: string) {
    this.loadingLocal = true;

    try {
      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PERSON, this.partnerId)) {
        PersonSearchModule.setSearch(search);
        await PersonSearchModule.fetchPage({ partnerId: this.partnerId });
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingLocal = false;
    }
  }
}
